import { ApiServerPath } from "api_server";
import axios from "axios";

export const ValidateExternalLink = async (link: string) => {
    try {
      const { data }: { data: any } = await axios.post(
        `${ApiServerPath.API_SERVER_BASE_URL}${ApiServerPath.VALIDATE_LINK}`,
        {
          link,
        }
      );
  
      if (data?.results?.success) {
        return data?.results?.isValid;
      } else if (data?.error?.message) {
        return false;
      }

    console.log(data, "data response");
    } catch (error) {
      console.log(error, "error");
    }
  };